export type RuntimeConfig = {
  PUBLIC_URL?: string;
  MATOMO_URL?: string;
  MATOMO_SITE_ID?: string;
  RELEASE?: string;
  CONTACT_EMAIL?: string;
  WHATSAPP_PHONE?: string;
};

declare global {
  interface Window {
    __VERLOFKAART_CONFIG__?: RuntimeConfig;
  }
}

const buildConfig: RuntimeConfig = {
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL,
  MATOMO_URL: import.meta.env.VITE_MATOMO_URL,
  MATOMO_SITE_ID: import.meta.env.VITE_MATOMO_SITE_ID,
  RELEASE: import.meta.env.VITE_RELEASE,
  CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
  WHATSAPP_PHONE: import.meta.env.VITE_WHATSAPP_PHONE,
};

export function configValue(key: keyof RuntimeConfig) {
  return window.__VERLOFKAART_CONFIG__?.[key] || buildConfig[key] || "";
}
